let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a7oQV")).then(() => parcelRequire('jxmii'));